module.exports = require("./sr-Latn.d.ts");